<template>
  <div class="auth-wrapper">
    <v-card exact class="pa-8" :height="height" :width="width">
      <v-card-title
        primary-title
        :class="titleStyle"
        class="d-flex justify-center pa-0"
      >
        <div class="maropost-logo">
          <v-img
            contain
            height="24px"
            width="252px"
            alt="Maropost admin logo"
            :src="$images.maropostFormLogo"
          />
        </div>
      </v-card-title>
      <v-card-text class="pa-0">
        <!-- Default slot -->
        <slot></slot>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
const [HEIGHT, WIDTH] = ["392px", "448px"];
/**
 * Auth form wrapper
 */
export default {
  name: "AuthFormsWrapper",
  /**
   * ---------------- Props ----------------
   */
  props: {
    /**
     * Top header title styles
     */
    titleStyle: {
      type: String,
      default: "pb-8",
    },
    /**
     * Height oof the card wrapper
     */
    height: {
      type: [String, Number],
      default: HEIGHT,
    },
    /**
     * Width of the wrapper
     */
    width: {
      type: [String, Number],
      default: WIDTH,
    },
  },
  /**
   * ---------------- Computed properties ----------------
   */
  computed: {},
};
</script>
